export default "__VITE_ASSET__DScT7TH8__"